import { defineStore } from 'pinia';
import MetaCampaignsDashboardAPI from 'dashboard/api/metaCampaignsDashboard';

export const useMetaCampaignsDashboardStore = defineStore(
  'metaCampaignsDashboard',
  {
    state: () => ({
      dashboard: null,
      uiFlags: {
        fetchingDashboard: false,
      },
    }),

    getters: {
      getDashboard: state => state.dashboard,
    },

    actions: {
      async fetchDashboard(params = {}) {
        this.uiFlags.fetchingDashboard = true;
        try {
          const { data } = await MetaCampaignsDashboardAPI.get(params);
          this.dashboard = data;
        } finally {
          this.uiFlags.fetchingDashboard = false;
        }
      },
    },
  }
);
